import {Component} from '@angular/core';
import {BaseModal} from '../modal-base';
import {ModalErrorArgs} from '../modal-error-args';

@Component({
    selector: 'support-dialog',
    templateUrl: './support-dialog.component.html',
    styleUrls: [
        './support-dialog.component.scss',
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css'
    ]
})



export class SupportDialogComponent extends BaseModal<any> {
    supportId:string;

    mailToString:string;

    constructor() {
        super();
      //  this.args = new ModalErrorArgs('', '');
    }

    onActivate(args: any) {
        this.supportId= args;
        this.mailToString ='mailto:support@ixiacom.com?subject=BreakingPoint%20Cloud%20Support%20For%20Test%20ID%20'+this.supportId+'&body=%0A%0A------------DO%20NOT%20REMOVE--------------%0A%0ABreakingPoint%20Cloud%20Test%20ID:%20'+this.supportId+'%0A%0A--------------DO%20NOT%20REMOVE------------%0A%0AYour%20message%20here'
    }

    onCloseClicked(e: MouseEvent) {
        e.preventDefault();
        this.closeDialog();
    }

    onClose() { }
}



// WEBPACK FOOTER //
// ./src/app/modals/support/support-dialog.component.ts